import { SampleConsensus } from './sac.js';

export class RandomSampleConsensus extends SampleConsensus {
  constructor(sacModel, threshold) {
    super()
    this.sacModel = sacModel;
    this.threshold = threshold;
    // this.probability = probability;
    // this.maxIterations = maxIterations;
    // this.threads = threads;
    this.iterations = 0;
    this.nBestInliersCount = 0;
    this.k = Number.MAX_VALUE;
    this.selection = [];
    this.modelCoefficients = [];
    this.inliers = [];
    this.model = [];
    this.maxSkip = this.maxIterations * 10;
    this.skippedCount = 0;
    this.logProbability = Math.log(1.0 - this.probability);
    this.oneOverIndices = 1.0 / this.sacModel.getIndices().length;
  }
  async computeModel() {
    // Warn and exit if no threshold was set
    if (this.threshold === Number.MAX_VALUE) {
      console.error("[RandomSampleConsensus::computeModel] No threshold set!");
      return false;
    }

    let threads = this.threads;
    if (threads >= 0) {
      threads = threads === 0 ? navigator.hardwareConcurrency : threads; // Automatic threads based on CPU
    }

    console.debug("[RandomSampleConsensus::computeModel] Computing with", threads, "threads.");

    // Parallelize the computation
    let parallelTasks = [];
    for (let t = 0; t < threads; t++) {
      parallelTasks.push(this.computeInParallel());
    }



    if (this.model.length === 0) {
      console.error("[RandomSampleConsensus::computeModel] RANSAC found no model.");
      this.inliers = [];
      return false;
    }

    // Get the set of inliers corresponding to the best model found
    console.log(`b computeModel :selectWithinDistance this.inliers size: ${this.inliers.length} `);
    this.sacModel.selectWithinDistance(this.modelCoefficients, this.threshold, this.inliers);
    console.log(`e computeModel :selectWithinDistance this.inliers size: ${this.inliers.length} `);

    await Promise.all(parallelTasks)
      .then(() => {
        console.log('所有线程运行完毕');
      })
      .catch((error) => {
        console.error('某个线程执行失败:', error);
      });
    return true;
  }

  async computeInParallel() {
    console.log('computeInParallel 开始');
    let selection = [];
    let modelCoefficients = [];
    // Iteration loop with stopping conditions
    while (true) {
      // Get X samples which satisfy the model criteria
      this.sacModel.getSamples(this.iterations, selection);

      if (selection.length === 0) {
        console.error("[RandomSampleConsensus::computeModel] No samples could be selected!");
        break;
      }
      // this.selection[0] = 11797;
      // this.selection[1] = 3581;
      // this.selection[2] = 21380;
      // Compute model coefficients based on selected samples
      // let selection;
      modelCoefficients = this.sacModel.computeModelCoefficients(selection);
      console.log(`computeInParallel :selection: ${selection[0]}x + ${selection[1]}y + ${selection[2]}z `);
      console.log(`computeInParallel :modelCoefficients ${modelCoefficients[0]}x + ${modelCoefficients[1]}y + ${modelCoefficients[2]}z + ${modelCoefficients[3]} = 0`);
      if (!modelCoefficients) {
        this.skippedCount++;
        if (this.skippedCount < this.maxSkip) continue;
        else break;
      }
      // this.modelCoefficients[0] = 0.991959;
      // this.modelCoefficients[1] = -0.0746037;
      // this.modelCoefficients[2] = -0.102235;
      // this.modelCoefficients[3] = 4.50822;

      // Count inliers
      const nInliersCount = this.sacModel.countWithinDistance(modelCoefficients, this.threshold);

      if (nInliersCount > this.nBestInliersCount) {
        console.log(`------------------computeInParallel :nInliersCount: ${nInliersCount}x `);

        // Better match?
        this.nBestInliersCount = nInliersCount;
        // this.model = [...this.selection];
        this.model = selection;
        // this.modelCoefficients = [...this.modelCoefficients];
        this.modelCoefficients = modelCoefficients;

        // Compute k (number of iterations needed)
        const w = this.nBestInliersCount * this.oneOverIndices;
        let pOutliers = 1.0 - Math.pow(w, selection.length); // Probability of outliers
        pOutliers = Math.max(Number.MIN_VALUE, pOutliers);
        pOutliers = Math.min(1.0 - Number.MIN_VALUE, pOutliers);
        this.k = this.logProbability / Math.log(pOutliers);
      }

      this.iterations++;
      console.debug(`[RandomSampleConsensus::computeModel] Trial ${this.iterations} out of ${this.k}: ${nInliersCount} inliers (best is: ${this.nBestInliersCount} so far).`);
      if (this.iterations > this.k || this.iterations > this.maxIterations) {
        break;
      }

    }
    console.log('computeInParallel 结束');
  }
}